import type { CommentResponse, RootComment } from '@gcv/shared';

export const getCommentById = (
  comments: RootComment[],
  id: string
): RootComment | CommentResponse | undefined => {
  for (const comment of comments) {
    if (comment.id === id) {
      return comment;
    }

    if (comment.children) {
      const child = comment.children.find((c) => c.id === id);
      if (child) {
        return child;
      }
    }
  }

  return undefined;
};
